// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2mb70","badges":"styles_badges__3HjsX"};